import { render, staticRenderFns } from "./CommonRadio.vue?vue&type=template&id=3c684ad0&scoped=true&"
import script from "./CommonRadio.vue?vue&type=script&lang=ts&"
export * from "./CommonRadio.vue?vue&type=script&lang=ts&"
import style0 from "./CommonRadio.vue?vue&type=style&index=0&id=3c684ad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c684ad0",
  null
  
)

export default component.exports